<script setup>
defineProps({
  game: {
    type: Object,
    required: true
  },
  isOriginal: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
  <div class="game-card" :class="{ 'original-card': isOriginal }">
    <router-link :to="`/game/${game.id}`">
      <div class="position-relative">
        <img :src="game.image" :alt="game.title" class="game-img w-100">
        <span v-if="game.tag" :class="`game-tag ${game.tag.toLowerCase()}`">{{ game.tag }}</span>
        <div class="game-title">{{ game.title }}</div>
      </div>
    </router-link>
  </div>
</template>

<style scoped>
.game-card {
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  background-color: #1a1b26;
}

.game-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.2);
}

.original-card .game-img {
  aspect-ratio: 3/4 !important;
}

.game-img {
  aspect-ratio: 16/12;
  object-fit: cover;
  display: block;
}

.game-tag {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: white;
}

.game-tag.new {
  background-color: #ff1493;
}

.game-tag.hot {
  background-color: #ff4d4d;
}

.game-tag.updated {
  background-color: #0e9f6e;
}

.game-title {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .game-title {
    font-size: 0.8rem;
    padding: 0.75rem;
  }
}
</style>